import { defineComponent as _defineComponent } from 'vue'
import { mdiClose } from '@mdi/js'
import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BKConfirmationDialog',
  props: {
    isShow: { type: Boolean },
    title: { default: '' },
    confirmText: { default: 'Confirm' }
  },
  emits: ["cancel", "confirm"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'cancel'): void
  (e: 'confirm'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isShow: boolean, title: string, confirmText: string };



const isShowValue = ref(props.isShow)

watch(
  () => props.isShow,
  (newVal) => {
    isShowValue.value = newVal
  }
)

watch(isShowValue, (val) => {
  if (!val) {
    emit('cancel')
  }
})

return { __sfc: true,props, emit, isShowValue, mdiClose }
}

})